import { render, staticRenderFns } from "./coupon-item.vue?vue&type=template&id=7563551d&scoped=true&lang=pug&"
import script from "./coupon-item.vue?vue&type=script&lang=js&"
export * from "./coupon-item.vue?vue&type=script&lang=js&"
import style0 from "./coupon-item.vue?vue&type=style&index=0&id=7563551d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7563551d",
  null
  
)

export default component.exports